import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CognitoUserDto, RoleDto, UserDto } from '@clearing-hub/common';
import {
  CreateUserCommand,
  UpdateApplicationAccessesCommand,
  UpdateUserRolesCommand,
} from '@clearing-hub/command';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private readonly http: HttpClient) {}

  preload() {
    return this.http.get('/adm/api/user-management');
  }

  updateUser(u: UpdateUserRolesCommand): Observable<void> {
    return this.http.post<void>('/adm/api/user-management/role', u);
  }

  updateApplicationAccesses(
    u: UpdateApplicationAccessesCommand,
  ): Observable<void> {
    return this.http.post<void>(
      '/adm/api/user-management/application-accesses',
      u,
    );
  }

  createUser(u: CreateUserCommand): Observable<CognitoUserDto> {
    return this.http.post<CognitoUserDto>(
      '/adm/api/user-management/create-user',
      u,
    );
  }

  deleteUser(email: string): Observable<ArrayBuffer> {
    return this.http.delete<ArrayBuffer>('/adm/api/user-management', {
      body: { email },
    });
  }

  setUserStatus(username: string, status: boolean): Observable<ArrayBuffer> {
    return this.http.post<ArrayBuffer>('/adm/api/user-management/status', {
      username,
      status,
    });
  }

  getUsersFromSpecificUserPool(userPoolId: string): Observable<Array<UserDto>> {
    return this.http.post<Array<UserDto>>(
      '/adm/api/user-management/user-pool',
      {
        userPoolId,
      },
    );
  }

  importUsers(command): Observable<void> {
    return this.http.post<void>(
      '/adm/api/user-management/import-users',
      command,
    );
  }

  getUserPools(): Observable<void> {
    return this.http.get<any>('/adm/api/user-management/user-pools');
  }

  updateUserAttributes(command): Observable<void> {
    return this.http.post<any>(
      '/adm/api/user-management/update-user-attributes',
      command,
    );
  }

  changeUserPassword(command): Observable<void> {
    return this.http.post<any>('/adm/api/user-management/password', command);
  }

  getUserRoles(command): Observable<Array<RoleDto>> {
    return this.http.post<Array<RoleDto>>(
      '/adm/api/user-management/user-groups',
      command,
    );
  }

  logout() {
    return this.http.post('/adm/api/authentication/signout', {});
  }
}
